import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {get} from '../Storage';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import WidgetSubAccounts from '../Widget/SubAccounts';
import WidgetLastLogins from '../Widget/LastLogins';
import CircularProgress from 'material-ui/CircularProgress';
import { Message, MGSiteButton } from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetAccountComponent';

var styles = AppSettings.styles;

class Account extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            errorMessage: "",
            data: {},
            showLoading: true,
            opened:false,
            balance: "",
            withdrawal: ""
        }

        this.getBalanceSubAccounts = this.getBalanceSubAccounts.bind(this);
    }

     getBalanceSubAccounts(event) {

        if(this.state.opened){
            this.setState({
                error: false,
                errorMessage: "",
                data: {},
                showLoading: true,
                opened:false,
                withdrawal: "",
                balance: ""
            });
            return;
        }
        
        this.setState({
            showLoading: true,
            opened:true
        });

        var url = AppSettings['env'].urlUserBoxBalanceSubaccounts;
        axios.get(url)
            .then(({data, status, statusText}) => {
                var showLoading = false;
                if (data.errors.length == 0) {
                    this.setState({
                        error: false,
                        errorMessage: "",
                        withdrawal: data.withdrawableAmount,
                        balance: data.balance,
                        showLoading: showLoading,
                        opened: true
                    });
                } else {
                    this.setState({
                        error: true,
                        errorMessage: <KeepAlive />,
                        data: {},
                        showLoading: showLoading,
                        opened: true,
                        withdrawal: "",
                        balance: ""
                    });
                }
            })
            .catch(function(error) {
                this.setState({
                    error: true,
                    errorMessage: "Errore durante il caricamento",
                    data: {},
                    showLoading: false,
                    opened: true,
                    withdrawal: "",
                    balance: ""
                });
            });
    }
  

    renderAccount(){

        if(this.state.showLoading){
            return <CircularProgress style={styles.loadingIcon}/>;
        }
        
        if(this.state.error){
            return <Message align="center">{this.state.errorMessage}</Message>;
        }

        var bonuses = "";
        if (this.props.data.bonuses.length > 0) {
            bonuses = this.props.data.bonuses.map(function (bonus, i) {
                var key = "bonus" + i;
                return (
                    <li key={key}>
                        <h3>{bonus.Key}</h3>
                        <span>{bonus.Value}</span>
                    </li>                )
            });
        }

        var clickEventModificaPassword = (e) => {
            this.context.openLinkPopup(e, AppSettings.urls.changePassword.href);
        }
        
        var clickEventEstrattoConto = (e) => {
            this.context.openLinkPopup(e, AppSettings.urls.statementOfAccount.href);
        }

        var clickEventModUserData = (e) => {
            this.context.openLinkPopup(e, AppSettings.urls.userData.href);
        }

        var clickEventModDatiAccount = (e) => {
            this.context.openLinkPopup(e, AppSettings.urls.updateAccount.href);
        }

        var clickEventCambiaPassword = (e) => {
            this.context.openLinkPopup(e, AppSettings.urls.changePassword.href);
        }

        var komodo = <></>
        
        if(AppSettings['perms'].komodo && AppSettings["isPartner"]){ 
            var hasAlias = AppSettings['komodo'] != undefined && AppSettings['komodo'].pvrAlias != null;
            //al momento faccio sempre vedere l'icona di modifica dell'alias
            var pvrAlias = hasAlias ? AppSettings['komodo'].pvrAlias : "Nessun alias configurato";
            komodo = <li className='mg-user-data-click' title='Modifica dati personali' onClick={clickEventModUserData}> 
                <h3>Komodo alias</h3>
                <span>{pvrAlias}</span>
                
                <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip="Modifica dati personali" iconClassName="fa-mg fa-mg-pen-to-square" 
                    //href={AppSettings.urls.userData.href} 
                    onClick={clickEventModUserData}
                    style={styles.cardMiniIcon} className="card-mini-icon"/> 
                
                {/*<UPage Tooltip="Modifica dati personali" PageTitle="Dati personali"><UpdateUser/></UPage>*/}
            </li>;
        }

        return (
            <>
            <ul className="mg-user-data-profile">
                
                <li className="mg-user-data-profile--name mg-user-data-click" title='Modifica dati personali' onClick={clickEventModUserData}>
                    <h3>Nome e Cognome</h3>
                    <span>{AppSettings['firstName']} {AppSettings['lastName']}                              
                    </span>
                    <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip="Modifica dati personali" iconClassName="fa-mg fa-mg-pen-to-square" 
                    href={AppSettings.urls.userData.href} 
                    onClick={clickEventModUserData}
                    style={styles.cardMiniIcon} className="card-mini-icon"/> 
                </li> 

                <li className="mg-user-data-profile--name" title='Codice Fiscale'>
                    <h3>Codice Fiscale</h3>
                    {/* this.props.data.ssn */}
                    <span>{this.props.data.ssn}</span>
                    {/* <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip="Modifica dati personali" iconClassName="fa fa-cog" 
                    href={AppSettings.urls.userData.href} 
                    onClick={clickEventModUserData}
                    style={styles.cardMiniIcon} className="card-mini-icon"/>  */}
                </li> 

                <li className="mg-user-data-profile--name" title='Profilo'>
                    <h3>Profilo</h3>
                    {/* this.props.data.usernameDescription */}
                    <span>{this.props.data.usernameDescription}</span>
                    {/* <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip="Modifica dati personali" iconClassName="fa fa-cog" 
                    href={AppSettings.urls.userData.href} 
                    onClick={clickEventModUserData}
                    style={styles.cardMiniIcon} className="card-mini-icon"/>  */}
                </li>  
           
                <li title="Estratto Conto" className='mg-user-data-click' onClick={clickEventEstrattoConto}>
                    <h3>Saldo disponibile aggregato</h3>
                    <span> {this.state.balance}</span>
                    <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip="Estratto Conto" iconClassName="fa-mg fa-mg-pen-to-square" 
                    //href={AppSettings.urls.statementOfAccount.href} 
                    onClick={clickEventEstrattoConto}
                    style={styles.cardMiniIcon} className="card-mini-icon"/> 

                </li>

                {(() => {
                        if(!AppSettings["isPartner"]){
                            return (
                                <li title="Estratto Conto " className='mg-user-data-click'  onClick={clickEventEstrattoConto}>
                                    <h3>Importo prelevabile aggregato</h3>
                                    <span>{this.state.withdrawal}</span>
                                    <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip="Estratto Conto" iconClassName="fa-mg fa-mg-pen-to-square" 
                                    href={AppSettings.urls.statementOfAccount.href} 
                                    onClick={clickEventEstrattoConto}
                                    style={styles.cardMiniIcon} className="card-mini-icon"/>
                                </li>
                            );
                        }
                })()}
              
                
                <li  title="Modifica dati account" className=' mg-user-data-click' onClick={clickEventModDatiAccount}>
                    <h3>Data scadenza account</h3>
                    <span>{this.props.data.accountExpiration}</span>
                    <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip="Modifica dati account" iconClassName="fa-mg fa-mg-pen-to-square" 
                        //href={AppSettings.urls.updateAccount.href} 
                        onClick={clickEventModDatiAccount}
                        style={styles.cardMiniIcon} className="card-mini-icon"/> 
                </li>
                
                {this.props.data.passwordExpiration != "" ? 
                    <li className="mg-user-data-profile--password mg-user-data-click" title="Modifica password"  onClick={clickEventCambiaPassword}>
                        <h3>Data scadenza password</h3>
                        <span>{this.props.data.passwordExpiration}</span>
                        <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip="Modifica password" iconClassName="fa-mg fa-mg-pen-to-square" 
                        //href={AppSettings.urls.changePassword.href} 
                        onClick={clickEventCambiaPassword}
                        style={styles.cardMiniIcon} className="card-mini-icon"/> 
                    </li>
                : ""}

               

                {komodo}

                {bonuses}
                </ul>
                {/*className="mg-user-data-profile-oth" */}
            <ul className="mg-user-data-profile mg-user-data-profile-oth" >
                <li className="mg-user-data-profile--btn" style={styles.noBorder}>
                    <MGSiteButton
                        title="Dati Account"
                        label="Dati Account"
                        disabled={false}
                        primary={true}
                        isButton={true}
                        fullWidth={true}
                        actionFunc={clickEventModDatiAccount}
                    />                     
                </li>
                <li className="mg-user-data-profile--btn" style={styles.noBorder}>
                    <MGSiteButton
                        title="Dati Personali"
                        label="Dati Personali"
                        disabled={false}
                        primary={true}
                        isButton={true}
                        fullWidth={true}
                        actionFunc={clickEventModUserData}
                    />
                </li>

                <li className="mg-user-data-profile--btn" style={styles.noBorder}>
                    <MGSiteButton
                        title="Modifica password"
                        label="Modifica password"
                        disabled={false}
                        primary={true}
                        isButton={true}
                        fullWidth={true}
                        actionFunc={clickEventModificaPassword}
                    />
                     
                </li>
                { 
                       !AppSettings['isPartner'] ?
                       //visualizzo contratto
                       <li className="mg-user-data-profile--btn--mini" style={styles.noBorder}>
                          <a href='/contractviewer.ashx'>Il mio contratto</a>
                       </li>
                     : null
                   }
                {/*  
                <li style={styles.noBorder}>
                    <WidgetSubAccounts />
                </li>
                    <li style={styles.noBorder}> 
                    <WidgetLastLogins />
                </li>
                */}

            </ul>
            </>
        );
    }
 
    // render() {
    //     // var title = <div style={styles.pointer} onClick={this.getBalanceSubAccounts}>I tuoi dati</div>;
    //     return (  
    //         <MGCard  
    //         title={"I tuoi dati"} 
    //         subtitle="Modifica dati"
    //         icons= "fa-mg fa-mg-user-2 mg-user-icon"
    //         expanded={this.state.opened} 
    //         renderComponent={this.renderAccount()} />        
    //     );
    // }
    render() {
        var title = <div style={styles.pointer} onClick={this.getBalanceSubAccounts}>I tuoi dati</div>;
        return (  
            <div id="mg-tuo-account" className='mg-user-widget'>
             
                <Card  
                        className="mg-tuo-account" 
                        expanded={this.state.opened} 
                        onExpandChange={this.getBalanceSubAccounts} 
                        containerStyle={styles.mgCardStyle}  
                        style={styles.primaryBorderColor}>
                    <CardHeader titleStyle={styles.mgCardTitle}
                                subtitleStyle={styles.mgCardSubTitle}
                                title={title}
                                //subtitle={subTitle}
                                subtitle="Modifica dati"
                                actAsExpander={false}
                                avatar={<i className="fa-mg fa-mg-user-2 mg-user-icon"/>} 
                                showExpandableButton={true}

                    />
                    <CardText expandable={true} style={styles.cardText}>
                        {this.renderAccount()}
                        {/* Widget Utente */}
                        {(() => {
                            if(!AppSettings["isPartner"]){
                                return (
                                    <WidgetSubAccounts />
                                );
                            }
                        })()}
                        <WidgetLastLogins />
                    </CardText>
                </Card>
            </div>

        );
    }
}

Account.displayName = componentName;

// PropTypes validation
Account.propTypes = {
    data: PropTypes.object.isRequired
};
Account.contextTypes = {
    openLinkPopup: PropTypes.func
}
// default props
Account.defaultProps = {
    data:{}
};

export default Account;